export default __webpack_public_path__ + "static/course-3d58a86a39d592ab46cbc5f3680b89a1.webm";